import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getContract = contractId => {
  return dispatch => {
    dispatch({ type: "GET_CONTRACT_LOADING" });
    api
      .contractGet(contractId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetContractErrorAlertTitle",
          "Virhe työsopimuksen lukemisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_CONTRACT_SUCCEEDED",
  payload: { detailContract: data },
});

const operationFailed = () => ({
  type: "GET_CONTRACT_FAIL"
});